import { render, staticRenderFns } from "./add_coupon.vue?vue&type=template&id=5be0fbb1&scoped=true"
import script from "./add_coupon.vue?vue&type=script&lang=js"
export * from "./add_coupon.vue?vue&type=script&lang=js"
import style0 from "./add_coupon.vue?vue&type=style&index=0&id=5be0fbb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0fbb1",
  null
  
)

export default component.exports